import { fetch } from '../../utils';
import qs from 'qs';

export const getSubscriptionPlansApi = queryObj => {
  return fetch(
    `${process.env.PFPLUS_SUBSCRIPTION_SERVICE_URL}/subscription-plans?${qs.stringify(queryObj)}`,
    {
      method: 'GET',
      credentials: 'omit'
    },
    false
  )
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};
